module.exports = __webpack_public_path__ + "static/media/youtube.ba469e24.svg";